



































import { List, Image } from "vant";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LinkAccount from "@/views/h5-page/account/Component/LinkAccount.vue";
import GroupDetail from "@/views/h5-page/account/Component/GroupDetail.vue";
export const EventBus = new Vue();
//   import { ocrIdCard } from "@/apis";

@Component({
  name: 'GroupList',
  components: {
    GroupDetail,
    LinkAccount,
    [List.name]: List,
    [Image.name]: Image
  }
})


export default class GroupList extends Vue {



  active = 0;
  list: any = [];
  loading = false;
  finished = true;
  showLinkAccount = false;
  showGroupDetail = false;
  groupList = [];
  title = "";




  @Prop({
    type: Boolean,
    default: false
  })
  private refresh;

  @Watch("refresh")
  watchValue(newVal) {
    this.getGroupList();
    
  }



  async created() {
    await this.getGroupList();
    this.checkPopup();
  }




  getGroupList() {
    return (this as any).$apis.groupList()
      .then(res => {
        
        this.list = res.data
        const { key, img } = res;
      })
      .catch(e => {
        
      });
  }
  checkPopup() {
    try {
        // 确保activeIndex存在且是数字类型，并检查其是否在预期的数组内
        const activeIndex = this.$route.query.activeIndex;
        if (typeof activeIndex === 'string' && ![1, 2].includes(Number(activeIndex))) {
            throw new Error(`Invalid activeIndex: ${activeIndex}`);
        }
        const index = Number(activeIndex); // 将activeIndex转换为数字
        const foundItem = this.list.find(item => item.id === index);
        if (foundItem !== undefined) {
            this.getGroupTradeList(foundItem);
        }
    } catch (error) {
        
    }
  }


  getGroupTradeList(item) {
    //赋值弹窗的title
    
    (this as any).title = item.group_name;
    
    const param = { group_id: item.id };
    (this as any).$apis
      .groupTradeList(param)
      .then(res => {
        (this as any).groupList = res;
        (this as any).showGroupDetail = true;
        
      })
      .catch(e => {
        
      });
  }


  onload() { 
  }
  onLinkAccountSuccess() {
    (this as any).showLinkAccount = false;
  }
  onGroupDetailClose() {
    (this as any).showGroupDetail = false;
  }
  setSuccess() {
    this.$emit('outputRedirect');
  }
}

